import * as React from 'react';
import { observer, inject } from 'mobx-react';
import {observable, action, computed} from 'mobx';
import { Grid, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment, List, ListItem, ListItemText, Typography, MenuItem, Switch, Checkbox, FormControlLabel, DialogContentText } from '@material-ui/core';
import AuthStore from 'src/stores/AuthStore';
import KlientStore from 'src/stores/KlientStore';
import SearchIcon from '@material-ui/icons/Search';
import Klient from 'src/models/Klient';
import { DatePicker } from 'material-ui-pickers';
import moment from 'moment';
import TurnusStore from 'src/stores/TurnusStore';
import Turnus from 'src/models/Turnus';
import CiselnikyStore from 'src/stores/CiselnikyStore';
import { isUndefined } from 'util';

export interface IClientNewDialogProps {
    open;
    onClose: (event?: any) => void;
    onAdd: (cl: Klient) => void;
    clientTemplate?: Klient;
    ciselnikyStore?: CiselnikyStore;
}

@inject('ciselnikyStore')
@observer
class ClientNewDialog extends React.Component<IClientNewDialogProps>{

    private clientBacking: Klient = null;
    @computed private get client(): Klient {
        if(this.clientBacking == null) {
            if(!isUndefined(this.props.clientTemplate)) {
                this.clientBacking = this.props.clientTemplate.clone();
            } else {
                this.clientBacking = new Klient();
            }
        }
        return this.clientBacking;
    }

    @action
    private handleChange = name => event => {
        this.client[name] = event.target.value;
    }

    private doOnAdd = () => {
        this.props.onAdd(this.client);
    }

    private doOnClose = () => {
        this.props.onClose();
        this.clientBacking = null;
    }

    public render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.doOnClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Nový klient</DialogTitle>
                <DialogContent>
                        <DialogContentText>
                            Zadejte údaje nového klienta
                        </DialogContentText>

                        <Grid container spacing={8}>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Jméno"
                                    type="string"
                                    value={this.client.jmeno}
                                    onChange={this.handleChange('jmeno')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="lastName"
                                    label="Příjmení"
                                    type="string"
                                    value={this.client.prijmeni}
                                    onChange={this.handleChange('prijmeni')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="phone"
                                    label="Telefon"
                                    type="string"
                                    value={this.client.telefon}
                                    onChange={this.handleChange('telefon')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="email"
                                    label="Email"
                                    type="string"
                                    value={this.client.email}
                                    onChange={this.handleChange('email')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="street"
                                    label="Ulice/ČP"
                                    type="string"
                                    value={this.client.ulice}
                                    onChange={this.handleChange('ulice')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="city"
                                    label="Město"
                                    type="string"
                                    value={this.client.mesto}
                                    onChange={this.handleChange('mesto')}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    id="zip"
                                    label="PSČ"
                                    type="string"
                                    value={this.client.PSC}
                                    onChange={this.handleChange('PSC')}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="note"
                                    label="Poznámka"
                                    type="string"
                                    multiline
                                    fullWidth
                                    value={this.client.poznamka}
                                    onChange={this.handleChange('poznamka')}
                                />
                            </Grid>
                        </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.doOnClose} color="primary">
                        Storno
                    </Button>
                    <Button onClick={this.doOnAdd} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default ClientNewDialog;



// WEBPACK FOOTER //
// ./src/components/ClientNewDialog.tsx